import * as React from "react";
import styles from "./SelectableTextBox.module.scss";
import classnames from "classnames";
import { Tooltip } from "../tooltip/Tooltip";

export default function SelectableTextBox({ appProps, dataTestId, selected, text, onClick, disabled, style }) {
    return (
        <div className={styles["property-wrapper"]}>
            <Tooltip content={disabled && appProps?.getLocaleText("out-of-stock")}>
                <div
                    data-test-id={dataTestId}
                    style={style}
                    className={classnames(styles["property-content-size-wrapper"], selected && styles["selected-property"], disabled && styles["disabled-property"])}
                    onClick={disabled ? undefined : onClick}
                >
                    {/*{selected && showCheckbox && (*/}
                    {/*    <div className={styles["property-content-selected"]}>*/}
                    {/*        <CheckboxIcon width={"13px"} stroke={true} />*/}
                    {/*    </div>*/}
                    {/*)}*/}
                    {/*{disabled && <div className={styles["disabled-property-line"]}/>}*/}
                    <span
                        style={{
                            whiteSpace: text?.length < 30 && "nowrap",
                        }}
                    >
                        {text}
                    </span>
                </div>
            </Tooltip>
        </div>
    );
}
